import '@hotmart/cosmos/dist/alert'
import '@hotmart/cosmos/dist/toast'

import '@hotmart/cosmos/dist/alert/variations/info.css'
import '@hotmart/cosmos/dist/alert/variations/success.css'
import '@hotmart/cosmos/dist/alert/variations/danger.css'
import '@hotmart/cosmos/dist/alert/variations/warning.css'

type ToastProps = {
  className?: string
}

const Toast = ({ className }: ToastProps) => {
  return <hot-toast data-test='hot-toast' class={className}></hot-toast>
}

export default Toast
